import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

export class CheckboxItem {
    id: number;
    name: string;
    checked: boolean;
    disabled: boolean;
}

@Component({
    selector: 'checkbox-selector',
    templateUrl: './checkbox-selector.component.html',
    styleUrls: ['./checkbox-selector.component.scss',
        '../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})
export class CheckboxSelectorComponent implements OnInit {
    
    @Input() items: CheckboxItem[] = [];
    @Input() contentHeight: number = 640;

    @Output() onContinueEvent: EventEmitter<number[]> = new EventEmitter<number[]>();
    @Output() onCancelEvent: EventEmitter<any> = new EventEmitter<any>();

    checkBoxItems: CheckboxItem[] = [];

    ngOnInit(): void {
        this.checkBoxItems = this.items;
    }

    onCheckboxChange(item: CheckboxItem) {
        item.checked = !item.checked;
    }

    cancel() {
        this.onCancelEvent.emit();
    }

    continue() {
        let selectedItemIds = this.checkBoxItems.filter(x => x.checked).map(x => x.id);
        this.onContinueEvent.emit(selectedItemIds);
    }
}